export default {
  topicsData:{},
  userData:{},
  topicVersionsData:{},
  topicVerReviewData:{},
  productData:[],
  explanationData:[],
  statusData:[],
  countryData:[],
  searchData:[],
  abstractDataList:[]
};
